<script>
import configure from '../tools/configurator/configure'

export default {
  name: 'environmenttexturesList',
  components: {},
  computed: {
    environmenttextures () {
      const state = this.$store.getters['environmenttexturesList/getState']
      return state.environmenttextures
    }
  },
  methods: {
    setEnvironmentTexture (environmentItem) {
      configure.SetEnvironment(environmentItem.payload)
    }
  }
}
</script>

<template>
<div class="environmenttextures-list">
  <md-list-item v-for="(item, index) in environmenttextures" :key="index" @click="setEnvironmentTexture(item)">
      {{item.title}}
  </md-list-item>
</div>
</template>

<style lang="scss" scoped>
</style>
